import React, { Component, Fragment } from 'react'
import { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import favicon from '../../images/favicon.png'
import appleTouchIcon from '../../images/apple-touch-icon.png'
import GlobalStyle from '../../styles/global'
import theme from '../../styles/theme'
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'

export default class Template extends Component {
  componentDidMount() {
    // Gatsby is SSR, so need to initialise wowjs in client side only
    if (typeof window !== 'undefined') {
      window.WOW = require('wowjs')
    }
    // Initialise animation library (disable eslint because I need to get it running SSR)
    /* eslint-disable-next-line */
    new WOW.WOW({
      live: false,
    }).init()
  }

  render() {
    const { children, lighttheme, isLegalPage } = this.props

    return (
      <div className="siteRoot">
        <Helmet>
          <meta charSet="utf-8" />
          <meta httpEquiv="x-ua-compatible" content="ie=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" type="image/png" href={favicon} />
          <link rel="apple-touch-icon" type="image/png" href={appleTouchIcon} />
        </Helmet>

        <ThemeProvider theme={theme}>
          <Fragment>
            <div className={isLegalPage ? 'siteContent leftAlign' : 'siteContent'}>
              <Navigation lighttheme={lighttheme} />
              {children}
            </div>
            <Footer />
          </Fragment>
        </ThemeProvider>
        <GlobalStyle />
      </div>
    )
  }
}

Template.propTypes = {
  children: PropTypes.node.isRequired,
  lighttheme: PropTypes.bool,
  isLegalPage: PropTypes.bool,
}

Template.defaultProps = {
  lighttheme: false,
  isLegalPage: false,
}
